import StatsLogic from './Logic/StatsLogic';

const moment = require('moment');

const initialState = {
  // conversation stats
  sentMessagesByDay: [],
  messagesSentBySource: [],
  newConversationsByDay: [],
  chatGPTConversationsByDay: [],
  conversationRatings: [],
  closedConversationsByDay: [],
  conversationPerHour: [],
  medianResponseTimeByDay: [],
  medianResponseTimeAggregate: 0,
  medianConversationLengthByDay: [],
  medianConversationLengthAggregate: 0,
  conversationsByChannel: [],
  conversationCurrentPeriod: [],
  conversationPreviousPeriod: [],
  conversationTopTagsStats: [],
  conversationStartDateFilter: null,
  conversationEndDateFilter: null,
  fetchingMessagesSentStats: false,
  fetchingMessagesSentSourceStats: false,
  fetchingConversationsByChannelStats: false,
  fetchingConversationStats: false,
  fetchingNewConversationStats: false,
  fetchingChatGPTConversationStats: false,
  fetchingConversationRatingsStats: false,
  fetchingClosedConversationStats: false,
  fetchingConversationResponseTimeStats: false,
  fetchingConversationResponseTimeAggregate: false,
  fetchingConversationLengthStats: false,
  fetchingConversationLengthAggregate: false,
  fetchingTopTagsStats: false,

  // Filters
  filteredChannels: [],
  filteredAgents: [],
  filteredAgentsAndTeams: [], // Like agent_3, team_1
  filteredBots: [],
  filteredTags: [],
  filteredRatings: [],

  numberOfMessagesByAgent: {},
  numberOfMessagesByTeam: {},
  // team stats
  fetchingAgentStats: false,
  fetchingTeamStats: false,
  agentStats: [],
  teamStats: [],
  startDateTeams: null,
  endDateTeams: null,
  // bots stats
  botsCurrentPeriod: [],
  botsResponses: [],
  botsResolvedConversations: [],
  botsTimeSaved: [],
  botsConversationLength: { bot: 0, human: 0, both: 0, all: 0 },
  botsClosedConversations: [],
  fetchingBotsResponses: false,
  fetchingBotResolvedConversations: false,
  fetchingBotsTimeSaved: false,
  fetchingBotsConversationLength: false,
  fetchingBotsClosedConversations: false,
  startDateBots: null,
  endDateBots: null,
  workHours: null,
};

const formatConversationStatsByDay = (conversations) => {
  const formattedConversations = conversations.reduce(
    (conversationsByDay, conversation) => {
      const day = moment(conversation.day).startOf('day').format('YYYY-MM-DD');
      if (!conversationsByDay[day]) {
        return Object.assign({}, conversationsByDay, { [day]: [conversation] });
      } else {
        return Object.assign({}, conversationsByDay, {
          [day]: conversationsByDay[day].concat(conversation),
        });
      }
    },
    {}
  );
  return formattedConversations;
};

const reductions = {
  // Messages Sent
  STARTED_FETCHING_MESSAGES_SENT_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingMessagesSentStats: true });
  },
  FAILED_FETCHING_MESSAGES_SENT_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingMessagesSentStats: false });
  },
  FETCHED_MESSAGES_SENT_STATS: (state, { payload }) => {
    const { messages } = payload;
    return Object.assign({}, state, {
      fetchingMessagesSentStats: false,
      sentMessagesByDay: messages,
    });
  },
  // Messages Sent Source
  STARTED_FETCHING_MESSAGES_SENT_SOURCE_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingMessagesSentSourceStats: true });
  },
  FAILED_FETCHING_MESSAGES_SENT_SOURCE_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingMessagesSentSourceStats: false });
  },
  FETCHED_MESSAGES_SENT_SOURCE_STATS: (state, { payload }) => {
    const { messages } = payload;
    return Object.assign({}, state, {
      fetchingMessagesSentSourceStats: false,
      messagesSentBySource: messages,
    });
  },
  // Closed Conversations
  STARTED_FETCHING_CLOSED_CONVERSATIONS_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingClosedConversationStats: true });
  },
  FAILED_FETCHING_CLOSED_CONVERSATIONS_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingClosedConversationStats: false });
  },
  FETCHED_CLOSED_CONVERSATIONS_STATS: (state, { payload }) => {
    const { conversations } = payload;
    return Object.assign({}, state, {
      fetchingClosedConversationStats: false,
      closedConversationsByDay: conversations,
    });
  },
  // Conversations Per Hour
  STARTED_FETCHING_CONVERSATIONS_PER_HOUR_STATS: (state, { payload }) => {
    if (!state.workHours) {
      return Object.assign({}, state, {
        fetchingConversationPerHourStats: false,
      });
    }
    return Object.assign({}, state, { fetchingConversationPerHourStats: true });
  },
  FAILED_FETCHING_CONVERSATIONS_PER_HOUR_STATS: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingConversationPerHourStats: false,
    });
  },
  FETCHED_CONVERSATIONS_PER_HOUR_STATS: (state, { payload }) => {
    const { conversations } = payload;
    return Object.assign({}, state, {
      fetchingConversationPerHourStats: false,
      conversationPerHour: conversations,
    });
  },
  STARTED_FETCHING_WORK_HOURS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingWorkHours: true });
  },
  FAILED_FETCHING_WORK_HOURS: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingWorkHours: false,
    });
  },
  FETCHED_WORK_HOURS: (state, { payload }) => {
    const { workHours } = payload;
    return Object.assign({}, state, {
      fetchingWorkHours: false,
      workHours,
    });
  },
  STARTED_UPDATING_WORKHOURS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingWorkHours: true });
  },
  UPDATED_WORKHOURS: (state, { payload }) => {
    const { workHours } = payload;
    return Object.assign({}, state, { fetchingWorkHours: false, workHours });
  },
  FAILED_UPDATING_WORKHOURS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingWorkHours: false });
  },

  /// NEW CONVERSATIONS
  STARTED_FETCHING_NEW_CONVERSATIONS_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingNewConversationStats: true });
  },
  FAILED_FETCHING_NEW_CONVERSATIONS_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingNewConversationStats: false });
  },
  FETCHED_NEW_CONVERSATIONS_STATS: (state, { payload }) => {
    const { conversations } = payload;
    return Object.assign({}, state, {
      fetchingNewConversationStats: false,
      newConversationsByDay: conversations,
    });
  },

  /// CHAT GPT CONVERSATIONS
  STARTED_FETCHING_CHAT_GPT_CONVERSATIONS_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingChatGPTConversationStats: true });
  },
  FAILED_FETCHING_CHAT_GPT_CONVERSATIONS_STATS: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingChatGPTConversationStats: false,
    });
  },
  FETCHED_CHAT_GPT_CONVERSATIONS_STATS: (state, { payload }) => {
    const { conversations } = payload;
    return Object.assign({}, state, {
      fetchingChatGPTConversationStats: false,
      chatGPTConversationsByDay: conversations,
    });
  },
  /// CONVERSATIONS TOP TAGS
  STARTED_FETCHING_TOP_CONVERSATION_TAGS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingTopTagsStats: true });
  },
  FAILED_FETCHING_TOP_CONVERSATION_TAGS: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingTopTagsStats: false,
    });
  },
  FETCHED_TOP_CONVERSATION_TAGS: (state, { payload }) => {
    const { tagsWithCount } = payload;
    return Object.assign({}, state, {
      fetchingTopTagsStats: false,
      conversationTopTagsStats: tagsWithCount.data,
    });
  },

  /// CONVERSATIONS RATINGS
  STARTED_FETCHING_CONVERSATION_RATINGS_STATS: (state) => {
    return Object.assign({}, state, {
      fetchingConversationRatingsStats: true,
    });
  },
  FAILED_FETCHING_CONVERSATION_RATINGS_STATS: (state) => {
    return Object.assign({}, state, {
      fetchingConversationRatingsStats: false,
    });
  },
  FETCHED_CONVERSATION_RATINGS_STATS: (state, { payload }) => {
    const { ratings } = payload;
    return Object.assign({}, state, {
      fetchingConversationRatingsStats: false,
      conversationRatings: ratings,
    });
  },

  // RESPONSE TIME
  STARTED_FETCHING_CONVERSATION_RESPONSE_TIME_STATS: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingConversationResponseTimeStats: true,
    });
  },
  FAILED_FETCHING_CONVERSATION_RESPONSE_TIME_STATS: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingConversationResponseTimeStats: false,
    });
  },
  FETCHED_CONVERSATION_RESPONSE_TIME_STATS: (state, { payload }) => {
    const { conversations } = payload;
    return Object.assign({}, state, {
      fetchingConversationResponseTimeStats: false,
      medianResponseTimeByDay: conversations,
    });
  },

  // RESPONSE TIME AGGREGATE
  STARTED_FETCHING_CONVERSATION_RESPONSE_TIME_AGGREGATE: (
    state,
    { payload }
  ) => {
    return Object.assign({}, state, {
      fetchingConversationResponseTimeAggregate: true,
    });
  },
  FAILED_FETCHING_CONVERSATION_RESPONSE_TIME_AGGREGATE: (
    state,
    { payload }
  ) => {
    return Object.assign({}, state, {
      fetchingConversationResponseTimeAggregate: false,
    });
  },
  FETCHED_CONVERSATION_RESPONSE_TIME_AGGREGATE: (state, { payload }) => {
    const medianResponseTimeAggregate = payload.median_first_response;
    return Object.assign({}, state, {
      fetchingConversationResponseTimeAggregate: false,
      medianResponseTimeAggregate,
    });
  },

  // CONVERSATION LENGTHS
  STARTED_FETCHING_CONVERSATION_LENGTH_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingConversationLengthStats: true });
  },
  FAILED_FETCHING_CONVERSATIONS_LENGTH_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingConversationLengthStats: false });
  },
  FETCHED_CONVERSATIONS_LENGTH_STATS: (state, { payload }) => {
    const { conversations } = payload;
    return Object.assign({}, state, {
      fetchingConversationLengthStats: false,
      medianConversationLengthByDay: conversations,
    });
  },

  // CONVERSATION LENGTH AGGREGATE
  STARTED_FETCHING_CONVERSATION_LENGTH_AGGREGATE: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingConversationLengthAggregate: true,
    });
  },
  FAILED_FETCHING_CONVERSATION_LENGTH_AGGREGATE: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingConversationLengthAggregate: false,
    });
  },
  FETCHED_CONVERSATION_LENGTH_AGGREGATE: (state, { payload }) => {
    const medianConversationLengthAggregate =
      payload.median_conversation_length;
    return Object.assign({}, state, {
      fetchingConversationLengthAggregate: false,
      medianConversationLengthAggregate,
    });
  },

  ///----------//
  STARTED_FETCHING_CONVERSATIONS_BY_CHANNEL_STATS: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingConversationsByChannelStats: true,
    });
  },
  FAILED_FETCHING_CONVERSATIONS_BY_CHANNEL_STATS: (state, { payload }) => {
    return Object.assign({}, state, {
      fetchingConversationsByChannelStats: false,
    });
  },
  FETCHED_CONVERSATIONS_BY_CHANNEL_STATS: (state, { payload }) => {
    const conversationsByChannel = payload.conversationsByChannel.sort((a, b) =>
      a.conversation_total > b.conversation_total ? -1 : 1
    );
    return Object.assign({}, state, {
      fetchingConversationsByChannelStats: false,
      conversationsByChannel,
    });
  },
  STARTED_FETCHING_CONVERSATION_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingConversationStats: true });
  },
  FAILED_FETCHING_CONVERSATION_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingConversationStats: false });
  },
  FETCHED_CONVERSATION_STATS: (state, { payload }) => {
    return Object.assign({}, state, { fetchingConversationStats: false });
  },
  CONVERSATION_DATE_RANGE_CHANGED: (state, { payload }) => {
    const { startDate, endDate } = payload;
    const conversationCurrentPeriod = StatsLogic.enumerateDaysBetweenDates(
      startDate,
      endDate,
      'YYYY-MM-DD'
    );
    const previousPeriodStartDate = StatsLogic.getPreviousPeriod(
      startDate,
      endDate
    );
    const conversationPreviousPeriod = StatsLogic.enumerateDaysBetweenDates(
      previousPeriodStartDate,
      startDate
    );
    return Object.assign({}, state, {
      conversationStartDateFilter: moment(startDate),
      conversationEndDateFilter: moment(endDate),
      conversationCurrentPeriod,
      conversationPreviousPeriod,
    });
  },
  CONVERSATION_AGENT_FILTER_CHANGED: (state, { payload }) => {
    const { filteredAgents, filteredAgentsAndTeams } = payload;
    return Object.assign({}, state, { filteredAgents, filteredAgentsAndTeams });
  },
  CONVERSATION_BOTS_FILTER_CHANGED: (state, { payload }) => {
    const { filteredBots } = payload;
    return Object.assign({}, state, { filteredBots });
  },
  CONVERSATION_TAGS_FILTER_CHANGED: (state, { payload }) => {
    const { filteredTags } = payload;
    return Object.assign({}, state, { filteredTags });
  },
  CONVERSATION_CHANNELS_FILTER_CHANGED: (state, { payload }) => {
    const { filteredChannels } = payload;
    return Object.assign({}, state, { filteredChannels });
  },
  CONVERSATION_STATS_FILTERS_UPDATED: (state) => {
    const agentFilter = (conversation) => {
      if (!state.filteredAgents || !state.filteredAgents.length) {
        return true;
      }
      return !!conversation.all_assigned_agent_ids.find((id) =>
        state.filteredAgents.includes(id)
      );
    };
    const botFilter = (conversation) => {
      if (!state.filteredBots || !state.filteredBots.length) {
        return true;
      }
      return !!state.filteredBots.includes(conversation.last_bot_id);
    };
    const tagFilter = (conversation) => {
      if (!state.filteredTags || !state.filteredTags.length) {
        return true;
      }
      return !!conversation.Tags.map((tag) => tag.id).find((id) =>
        state.filteredTags.includes(id)
      );
    };
    const channelFilter = (conversation) => {
      if (!state.filteredChannels || !state.filteredChannels.length) {
        return true;
      }
      return !!state.filteredChannels.includes(
        conversation.StatsConversation.initial_channel_id
      );
    };
    const conversationsByDay = Object.keys(
      state.conversationsUnfilteredByDay
    ).reduce((conversationsByDay, day) => {
      const conversations = state.conversationsUnfilteredByDay[day];
      const filtered = conversations.filter(
        (conversation) =>
          agentFilter(conversation) &&
          botFilter(conversation) &&
          tagFilter(conversation) &&
          channelFilter(conversation)
      );
      conversationsByDay[day] = filtered;
      return conversationsByDay;
    }, {});
    const conversationsClosedByDay = Object.keys(
      state.closedConversationsUnfilteredByDay
    ).reduce((conversationsClosedByDay, day) => {
      const conversations = state.closedConversationsUnfilteredByDay[day];
      const filtered = conversations.filter(
        (conversation) =>
          agentFilter(conversation) &&
          botFilter(conversation) &&
          tagFilter(conversation) &&
          channelFilter(conversation)
      );
      conversationsClosedByDay[day] = filtered;
      return conversationsClosedByDay;
    }, {});
    return Object.assign({}, state, {
      conversationsByDay,
      conversationsClosedByDay,
    });
  },
  CONVERSATION_PREDEFINED_DATE_RANGE_CHANGED: (state, { payload }) => {
    return {
      ...state,
      conversationPredefinedDateRange: payload.predefinedRange,
    };
  },
  CONVERSATION_CUSTOM_DATE_RANGE_TOGGLED: (state, { payload }) => {
    return {
      ...state,
      conversationCustomDateEnabled: payload.customDateRangeEnabled,
    };
  },

  START_FETCHING_AGENT_STATS: (state) => {
    return Object.assign({}, state, { fetchingAgentStats: true });
  },
  UPDATE_AGENT_STATS: (state, { payload }) => {
    const { agentStats } = payload;
    return Object.assign({}, state, { agentStats, fetchingAgentStats: false });
  },
  START_FETCHING_TEAM_STATS: (state) => {
    return Object.assign({}, state, { fetchingTeamStats: true });
  },
  UPDATE_TEAM_STATS: (state, { payload }) => {
    const { teamStats } = payload;
    return Object.assign({}, state, { teamStats, fetchingTeamStats: false });
  },
  FAILED_FETCHING_TEAM_STATS: (state) => {
    return Object.assign({}, state, { fetchingTeamStats: false });
  },
  TEAMS_DATE_RANGE_CHANGE: (state, { payload }) => {
    return Object.assign({}, state, {
      startDateTeams: payload.startDate,
      endDateTeams: payload.endDate,
    });
  },

  //____BOT STATS____//

  // GENERAL BOT STATS
  BOTS_DATE_RANGE_CHANGE: (state, { payload }) => {
    const { startDate, endDate } = payload;
    const botsCurrentPeriod = StatsLogic.enumerateDaysBetweenDates(
      startDate,
      endDate,
      'YYYY-MM-DD'
    );
    return Object.assign({}, state, {
      botsCurrentPeriod,
      startDateBots: moment(startDate).utc(),
      endDateBots: moment(endDate).utc(),
    });
  },

  // BOT RESPONSES - SUCCESSFUL MESSAGES
  START_FETCHING_BOTS_RESPONSES: (state) => {
    return Object.assign({}, state, { fetchingBotsResponses: true });
  },
  UPDATE_BOTS_RESPONSES: (state, { payload }) => {
    const botsResponses = formatConversationStatsByDay(payload.botsResponses);
    return Object.assign({}, state, {
      botsResponses,
      fetchingBotsResponses: false,
    });
  },
  FAILED_FETCHING_BOTS_RESPONSES: (state) => {
    return Object.assign({}, state, { fetchingBotResponses: false });
  },

  // TIME SAVED
  START_FETCHING_TIME_SAVED: (state) => {
    return Object.assign({}, state, { fetchingBotsTimeSaved: true });
  },
  UPDATE_TIME_SAVED: (state, { payload }) => {
    const botsTimeSaved = formatConversationStatsByDay(payload.botsTimeSaved);
    return Object.assign({}, state, {
      botsTimeSaved,
      fetchingBotsTimeSaved: false,
    });
  },
  FAILED_FETCHING_TIME_SAVED: (state) => {
    return Object.assign({}, state, { fetchingBotsTimeSaved: false });
  },

  // RESOLVED CONVERSATIONS
  START_FETCHING_BOT_RESOLVED_CONVERSATIONS: (state) => {
    return Object.assign({}, state, { fetchingBotResolvedConversations: true });
  },
  UPDATE_BOTS_RESOLVED_CONVERSATIONS: (state, { payload }) => {
    const botsResolvedConversations = formatConversationStatsByDay(
      payload.botsResolvedConversations
    );
    return Object.assign({}, state, {
      botsResolvedConversations,
      fetchingBotResolvedConversations: false,
    });
  },
  FAILED_FETCHING_BOTS_RESOLVED_CONVERSATIONS: (state) => {
    return Object.assign({}, state, {
      fetchingBotResolvedConversations: false,
    });
  },

  // CONVERSATION LENGTH
  START_FETCHING_BOTS_CONVERSATION_LENGTH: (state) => {
    return Object.assign({}, state, { fetchingBotsConversationLength: true });
  },
  UPDATE_BOTS_CONVERSATION_LENGTH: (state, { payload }) => {
    return Object.assign({}, state, {
      botsConversationLength: payload.botsConversationLength,
      fetchingBotsConversationLength: false,
    });
  },
  FAILED_FETCHING_BOTS_CONVERSATION_LENGTH: (state) => {
    return Object.assign({}, state, {
      fetchingBotsConversationLength: false,
    });
  },

  START_FETCHING_CLOSED_CONVERSATIONS: (state) => {
    return Object.assign({}, state, { fetchingBotsClosedConversations: true });
  },
  UPDATE_CLOSED_CONVERSATIONS: (state, { payload }) => {
    return Object.assign({}, state, {
      botsClosedConversations: payload.botsClosedConversations,
      fetchingBotsClosedConversations: false,
    });
  },
  FAILED_FETCHING_CLOSED_CONVERSATIONS: (state) => {
    return Object.assign({}, state, {
      fetchingBotsClosedConversations: false,
    });
  },

  FILTERED_RATINGS_CHANGED: (state, { payload }) => {
    return { ...state, filteredRatings: payload.filteredRatings };
  },
  RATINGS_SHOULD_USE_CONVERSATION_FILTERS: (state, { payload }) => {
    return {
      ...state,
      ratingsShouldUseConversationFilters: payload.useFilters,
    };
  },
  FILTERED_TAGS_CHANGED: (state, { payload }) => {
    return { ...state, filteredTags: payload.tagsWithCount?.data };
  },
  TAGS_SHOULD_USE_CONVERSATION_FILTERS: (state, { payload }) => {
    return {
      ...state,
      tagsShouldUseConversationFilters: payload.useFilters,
    };
  },
};

const statsRouteReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default statsRouteReducer;
